module.exports = __webpack_public_path__ + "static/media/notification.0185d7d9.svg";